import SinglePageView from './single-page-view'
import MultiPageView from './multi-page-view'
import * as PDFJS from 'pdfjs-dist/webpack.mjs'

const PDFViewer = () => {
  // IOS has a low limit on canvas sizes so we should only render a few pages at a time
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)

  return isIOS ? new SinglePageView(PDFJS) : new MultiPageView(PDFJS)
}

export default PDFViewer
